import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=a1bf9524&scoped=true"
import script from "./loading-overlay.vue?vue&type=script&lang=js"
export * from "./loading-overlay.vue?vue&type=script&lang=js"
import style0 from "./loading-overlay.vue?vue&type=style&index=0&id=a1bf9524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bf9524",
  null
  
)

export default component.exports